import {getWorkspaceFromUri} from '@dms/routes';

const CARVAGO_WORKSPACE = 'carvago';

/**
 * Carvago tests on DEV and STAGE in the `caraudit` workspace. Production keeps the feature in
 * `carvago` only.
 */
const CARVAGO_TEST_WORKSPACE = 'caraudit';

// An empty or unknown ENV_TYPE keeps the test workspace closed.
const CARVAGO_TEST_ENV_TYPES: ReadonlyArray<string> = ['dev', 'stage'];

/**
 * The inspection equipment document is a Carvago-only feature; every other workspace must not see
 * the controls at all. The backend does not check the workspace, so this rule is the only gate.
 * The digital certificate applies the same rule in
 * `apps/digital-certificate/src/utils/isCarvagoWorkspace.ts`; keep the two in sync.
 */
export function isCarvagoWorkspace() {
  const {workspace} = getWorkspaceFromUri();

  if (workspace === CARVAGO_WORKSPACE) {
    return true;
  }

  return (
    workspace === CARVAGO_TEST_WORKSPACE &&
    CARVAGO_TEST_ENV_TYPES.includes(process.env.ENV_TYPE ?? '')
  );
}
